import {
  type LanguageAction,
  Actions as LanguageActions,
} from 'src/components/Profile/Languages/actions';
import type { Analytics } from 'src/middlewares/createAnalyticsMiddleware';

import { instrumentAnalytics } from '../analyticsMiddlewareUtils';

export const createLanguagesAnalyticsMiddleware = (analytics: Analytics) =>
  instrumentAnalytics(analytics) &&
  (() =>
    (next: (action: LanguageAction) => void) =>
    (action: LanguageAction) => {
      const { updateCard } = analytics;

      switch (action.type) {
        case LanguageActions.UPDATE_LANGUAGE_START:
        case LanguageActions.REMOVE_LANGUAGE_START: {
          updateCard({
            actionName: action.actionName,
            currentPageSection: 'language',
          });

          break;
        }

        default: {
          break;
        }
      }

      return next(action);
    });
